var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Approx "+_vm._s(_vm.code)+": "),_c('span',{staticClass:"compare-vehicle-approx-price"},[_vm._v(_vm._s(_vm.formattedPrice))]),_c('VehiclePopoverCell',{attrs:{"id":1,"value":_vm.popoverIcon,"content":_vm.popoverContent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }